<template>
  <v-list-item :value="item.lang">
    <v-list-item-avatar size="24">
      <!--DEV Note: Unify with DefaultLocalSwitch selection/item slot styling -->
      <!-- REFACTOR: turn flag from emoji into sprite -->
      {{ item.flag }}
    </v-list-item-avatar>
    <v-list-item-title>{{ item.text }}</v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      validator(v) {
        return (
          v.lang !== undefined && v.flag !== undefined && v.text !== undefined
        );
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
